<template>
  <v-form ref="cashiersForm">
    <v-row>
      <v-col cols="12" md="12">
        <p class="text-h6">Información general</p>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-text-field
          v-model="dataForm.nam"
          :rules="rules.nam"
          label="Nombre"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-select
          v-model="dataForm.coi"
          :rules="rules.coi"
          outlined
          dense
          label="Tipo"
          item-value="id"
          item-text="text"
          :items="getComportamientos"
        ></v-select>
      </v-col>
    </v-row>
    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>

<style scoped></style>

<script>
import Cliente from "../../../clases/Cliente.js";
import { mapGetters } from "vuex";
export default {
  name: "TiposCreditoForm",
  components: {},
  props: ["edit", "dataEdit", "preloadData", "modeActionFinancial"],
  data() {
    return {
      tipos: [
        { id: "REV", text: "REVOLVENTE" },
        { id: "FIN", text: "FINANCIAMIENTO" },
        { id: "CON", text: "CONCEPTOS" },
      ],
      departamentos: [{ id: "DEFAULT", text: "GENERAL" }],
      showPlanPagos: false,
      dataForm: {
        nam: "",
        coi: "",
      },
      rules: {
        nam: [
          (value) => !!value || "El nombre del tipo de crédito es obligatorio",
        ],
        coi: [(value) => !!value || "El tipo es obligatorio"],
      },
    };
  },
  computed: {
    ...mapGetters("LineasCredito", ["getComportamientos"]),
  },
  methods: {
    showTable() {
      this.showPlanPagos = !this.showPlanPagos;
    },
    async getDepartamentosBnk() {
      const database = this.$store.getters.getFirebaseApp.database;
      let snapshot = await database.queryBuilder("BNK/Departamentos", []);
      if (snapshot.exists()) {
        let dep = Object.entries(snapshot.val());
        this.departamentos = [];
        dep.forEach((el) => {
          this.departamentos.push({ id: el[0], text: el[1].Nombre });
        });
      }
    },
    checkForm() {
      if (this.$refs.cashiersForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      let dataSave = this.dataForm;
      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.id;
      }
      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    if (this.edit) {
      this.dataForm = this.dataEdit;
    }

    this.getDepartamentosBnk();
  },
};
</script>
